export default "__VITE_ASSET__CP9Wkbzi__"